const namespace = 'str/auth/';

const authActionNames = {
  LOGIN_TO_APP: `${namespace}LOGIN_TO_APP`,
  LOGIN_WITH_CREDENTIALS: `${namespace}LOGIN_WITH_CREDENTIALS`,
  LOGIN_WITH_GOOGLE: `${namespace}LOGIN_WITH_GOOGLE`,
  LOGIN_WITH_FACEBOOK: `${namespace}LOGIN_WITH_FACEBOOK`,
  REGISTER_AND_LOGIN: `${namespace}REGISTER_AND_LOGIN`,
  LOGIN_SUCCESS: `${namespace}LOGIN_SUCCESS`,
  LOGOUT: `${namespace}LOGOUT`,
  LOGOUT_SUCCESS: `${namespace}LOGOUT_SUCCESS`,
  ADD_REDIRECT_PARAM: `${namespace}ADD_REDIRECT_PARAM`,
  RESET_REDIRECT_PARAM: `${namespace}RESET_REDIRECT_PARAM`,
};

export default authActionNames;
